import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import CartRoute from "../../features/cart/CartRoute";

const ShoppingCartPage = () => (
  <div className="shopping-cart-page full-bleed">
    <HexAuthWrapper>
      <CartRoute />
    </HexAuthWrapper>
  </div>
);

export default ShoppingCartPage;
